export default {
  account: {},
  userId: '',
  reverScore: 0,
  organization: {},
  organizationId: '',
  siteId: '',
  logoMediaObject: {},
  organizationMobileLogo: '',
  tags: [],
  token: '',
  accountOrganizations: [],
  hasFetchedAccountOrganizations: false,
  pendingOrgSwitch: null,
  isSwitchingOrganizations: false,
  switchingToOrganizationName: null,
  // We need to get the azure object here to get it in the refresh token function
  azure: JSON.parse(localStorage.getItem('azure')),
}
